import React, { useState, useEffect } from "react";
import { fetchUtils, Admin, Login, Resource } from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import PeopleIcon from '@mui/icons-material/People';
import StorefrontIcon from '@mui/icons-material/Storefront';
import MyLayout from './MyLayout';
import orders from './orders';
import orderdetails from './orderdetails';
// TODO: Fix remaining objects
import { OrderListExport } from './orders/OrderListExport';
import { CustomerList, CustomerEdit, CustomerCreate } from './Customers';
import { ProductList, ProductEdit, ProductCreate } from './Products';
import { DeliveryLocationList, DeliveryLocationEdit, DeliveryLocationCreate } from './DeliveryLocations';
import { PickupLocationList, PickupLocationEdit, PickupLocationCreate } from './PickupLocations';
import { TruckingCompanyList, TruckingCompanyEdit, TruckingCompanyCreate } from './TruckingCompanies';
import { TruckEdit, TruckCreate } from './Trucks';
import { ReportCreate } from './Reports';
import { UserList, UserEdit, UserCreate, UserShow } from './Users';
import { CustomerAccountList, CustomerAccountEdit, CustomerAccountCreate } from './CustomerAccounts';
import authProvider from './authProvider';
import { defaultTheme } from 'react-admin';
import CustomerPortalRouter from './customer/CustomerPortal';

const MyLoginPage = () => (
    <Login
        // A random image that changes everyday
        backgroundImage="https://source.unsplash.com/user/davidmarcu/1600x900"
    />
);

const myTheme = {
    ...defaultTheme,
    palette: {
        primary: {
            main: "#0b355d", // dark blue-grey (rgb(11, 53, 93)) - used for links, buttons, and primary UI elements
        },
        secondary: {
            main: "#52ad7a", // green
        },
    }
};

const fetchJson = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.headers.set('x-access-token', localStorage.getItem('token'));
    return fetchUtils.fetchJson(url, options);
}

// Dynamically use the current domain the UI is served from
// CI/CD pipeline: master push -> staging deploy -> E2E tests -> manual production
const apiUrl = `${window.location.protocol}//${window.location.hostname}`;
const dataProvider = jsonServerProvider(`${apiUrl}/api`, fetchJson);

const AdminApp = ({ customerPortalEnabled }) => {
  console.log('API URL:', apiUrl);

  return (
    <Admin layout={MyLayout} theme={myTheme} loginPage={MyLoginPage} authProvider={authProvider} dataProvider={dataProvider}>
      <Resource name="orders" options={{ label: 'Orders' }} {...orders} />
      <Resource name="customers" options={{ label: 'Customers' }} list={CustomerList} edit={CustomerEdit} create={CustomerCreate} />
      <Resource
        name="users"
        options={{ label: 'Users', adminOnly: true }}
        icon={PeopleIcon}
        list={UserList}
        edit={UserEdit}
        create={UserCreate}
        show={UserShow}
      />
      <Resource name="products" options={{ label: 'Products' }} list={ProductList} edit={ProductEdit} create={ProductCreate} />
      <Resource name="pickuplocations" options={{ label: 'Pickup Locations' }} list={PickupLocationList} edit={PickupLocationEdit} create={PickupLocationCreate} />
      <Resource name="deliverylocations" options={{ label: 'Delivery Locations' }} list={DeliveryLocationList} edit={DeliveryLocationEdit} create={DeliveryLocationCreate} />
      <Resource name="truckingcompanies" options={{ label: 'Trucking Companies' }} list={TruckingCompanyList} edit={TruckingCompanyEdit} create={TruckingCompanyCreate} />
      <Resource name="orderdetails" options={{ label: 'Order Reconciliation' }} {...orderdetails} />
      <Resource name="ordersexport" options={{ label: 'Orders Export' }} list={OrderListExport} />

      <Resource name="trucks" options={{ label: 'Trucks' }} edit={TruckEdit} create={TruckCreate} />
      <Resource name="precisions" options={{ label: 'Precisions' }} />
      <Resource name="units" options={{ label: 'Units' }} />
      <Resource name="reports" options={{ label: 'Reports' }} create={ReportCreate} />
      <Resource name="ordernums"/>
      <Resource name="releasenums"/>
      {customerPortalEnabled && (
        <Resource
          name="customeraccounts"
          options={{ label: 'Customer Accounts', adminOnly: true }}
          icon={StorefrontIcon}
          list={CustomerAccountList}
          edit={CustomerAccountEdit}
          create={CustomerAccountCreate}
        />
      )}
    </Admin>
  );
};

const App = () => {
    const [customerPortalEnabled, setCustomerPortalEnabled] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${apiUrl}/api/features`)
            .then(res => {
                if (!res.ok) throw new Error('Features endpoint not available');
                return res.json();
            })
            .then(data => {
                setCustomerPortalEnabled(data.customerPortal === true);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) return null;

    if (window.location.pathname.startsWith('/customer') && customerPortalEnabled) {
        return <CustomerPortalRouter />;
    }

    return <AdminApp customerPortalEnabled={customerPortalEnabled} />;
};

export default App;
